import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";

import { TokenStorageService } from "../_services/token-storage.service";
import { EMPTY, Observable, catchError, finalize, switchMap, throwError } from "rxjs";
import jwt_decode from "jwt-decode";
import { UserService } from "../_services/user.service";
import { Router } from "@angular/router";

const TOKEN_HEADER_KEY = "accessToken";
const TOKEN_HEADER_KEY_AUTH = "Authorization";
// for Spring Boot back-end
//const TOKEN_HEADER_KEY = 'x-access-token';   // for Node.js Express back-end

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private tokenService: TokenStorageService,
    private userService: UserService,
    private router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authReq = req;
    const token = this.tokenService.getToken();

    if (token != null) {
      var decodedToken: any = jwt_decode(token);
      var expired = Math.floor(new Date().getTime() / 1000) >= decodedToken.exp;

      if (expired) {
        this.tokenService.signOutExpirationAndRedirectTo("login");
        window.location.reload();
      } else {
        // Verificar si ya se está realizando una actualización del token
        if (!this.isRefreshing) {
          this.isRefreshing = true;

          // Realizar la actualización del token
          return this.userService.updateTokenExpiration().pipe(
            switchMap((data: any) => {
              if (data.status == "616") {
                this.tokenService.saveToken(data.token);
                //Peticion al back que actualiza los datos del usuario con el nuevo token
                this.userService.getCurrentUserFromServer().subscribe({
                  next: (data) => {
                    if (data.Usuario != null) {
                      this.tokenService.setUser(
                        data.Usuario,
                        data.usuarioRepresenta
                      );
                    }
                  },
                });
                this.userService.getCurrentUserFromServer();
                //si hacemos la llamada a power bi para refrescar la información de la BBDD tenemos que evitar que el token sea el de la app
                if(!(req.url.includes("https://api.powerbi.com/v1.0/myorg/datasets"))){
                // Clonar la solicitud original y agregar el nuevo token
                authReq = req.clone({
                  headers: req.headers
                    .set(TOKEN_HEADER_KEY_AUTH, "Bearer " + data.token)
                    .set(TOKEN_HEADER_KEY, data.token)
                    .set(
                      "Access-Control-Allow-Headers",
                      "accessToken,Authorization"
                    )
                    .set("Access-Control-Allow-Origin", "*"),
                });
              }
                // Reintentar la solicitud con el nuevo token
                return next.handle(authReq).pipe(
                  catchError((err) => this.handleTwoFactorEnrollmentRequired(err))
                );
              } else {
                // Si la actualización del token no fue bien hace un logout
                this.tokenService.signOutExpirationAndRedirectTo("login");
                return EMPTY;
              }
            }),
            finalize(() => {
              this.isRefreshing = false;
            })
          );
        }
      }

      authReq = req.clone({
        headers: req.headers
          .set(TOKEN_HEADER_KEY_AUTH, "Bearer " + token)
          .set(TOKEN_HEADER_KEY, token)
          .set("Access-Control-Allow-Headers", "accessToken,Authorization")
          .set("Access-Control-Allow-Origin", "*"),
      });
    }

    return next.handle(authReq).pipe(
      catchError((err) => this.handleTwoFactorEnrollmentRequired(err))
    );
  }

  private handleTwoFactorEnrollmentRequired(err: any): Observable<HttpEvent<any>> {
    if (err?.status === 403 && err?.error?.status === 'required2FA') {
      this.tokenService.setPending2FAEnrollment(true);
      this.router.navigate(['/login']);
      return EMPTY;
    }
    return throwError(() => err);
  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
